export default {

    BATHTUB: {
        stepOne: {
            menu: {
                title: 'Made-to-measure',
                body:  {
                    len: '2',
                    1:   'Base dimensions:',
                    2:   'Actual dimensions:',
                },
            },
            form: {
                title:  'Actual dimensions',
                width:  'WIDTH (CM)',
                length: 'LENGTH (CM)',
                to:     'to',
            },

        },
        stepTwo: {
            menu: {
                title: 'Tile flanges',
                body:  {
                    len:   '2',
                    1:     'Tile flange code',
                    2:     'Partial tile flange',
                    back:  'back',
                    front: 'front',
                    left:  'left',
                    right: 'right',
                },
            },
            form: {
                title:    'Tile flange code:',
                checkbox: 'Partial tile flange',
                left:     'Left',
                right:    'Right',
                back:     'Back',
                front:    'Front',
            },
            summary: {
                Z23: {
                    '1':  "Tile flange back",
                    '02': "Partial tile flange back left",
                    '03': "Partial tile flange back right"
                },
                Z45: {
                    '1':  "Tile flange right",
                    '04': "Partial tile flange right back",
                    '05': "Partial tile flange right front"
                },
                Z67: {
                    '1':  "Tile flange front",
                    '06': "Partial tile flange front right",
                    '07': "Partial tile flange front left"
                },
                Z81: {
                    '1':  "Tile flange left",
                    '01': "Partial tile flange left back",
                    '08': "Partial tile flange left front"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Corner options',
                title2: 'Corner options',
                body:  {
                    len: '1',
                    1:   'Corner(s) defined',
                    EA12: 'Back left',
                    EA34: 'Back right',
                    EA78: 'Front left',
                    EA56: 'Front right',
                },
            },
            form: {
                back_left:   'Back left',
                back_right:  'Back right',
                front_left:  'Front left',
                front_right: 'Front right',
            },

        },
        stepFour: {
            menu: {
                title: 'Boreholing for fittings',
                body:  {
                    len: '1',
                    1:   'Hole for single hole tap',
                    2:   'front right',
                    L1:  'Single hole tap',
                    L2:  'Custom round hole',
                    AT:  'Boreholing for made-to-measure fittings',
                },
            },
            form: {
                armatur_type:          'Fitting type',
                position:              'Position',
                checkbox:              'Partial tile flange',
                L1:                    'Single hole tap',
                L2:                    'Custom round hole',
                AT:                    'Boreholing for made-to-measure fittings',
                L2M:                   'mm',
                armatur:               'FITTING',
                armatur_placeholder:   'Supplier and model',
                anmerkung:             'REMARKS',
                anmerkung_placeholder: 'Example text',
                drawing_upload:        'UPLOAD DRAWING',
                drawing_necessary:     'Drawing required',
            },

        },
        stepFive: {
            menu: {
                title: 'Fittings',
                body:  {
                    len:  '1',
                    1:    'present',
                    SPV:  'SPLASH',
                    ALGV: '',
                },
            },
            form: {
                title:      'SURFACE TREATMENT',
                text_field: {
                    placeholder: 'Position for custome placement',
                },
                SPV:     'Fitting Schmidlin SPLASH',
                ALGV:    'Ab-/Überlaufgarnitur',
                options: [
                    'Colour',
                ],
                checkbox: {
                    label1: 'ANTIGLISS PRO',
                    label2: 'CLEANEFFECT',
                },
            },

        },
        stepSix: {
            menu: {
                title: 'Handles',
                body:  {
                    len: '1',
                    1:   'Present',
                    GR:  'Handle',
                },
            },
            form: {
                GR:         'With Handle(s)',
                text_field: {
                    placeholder: 'Remarks for custom design',
                },
            },

        },
        stepSeven: {
            menu: {
                title: 'Whirl systems',
                body:  {
                    len:         '2',
                    whirlsystem: 'Whirl system',
                    TA:          'Temperature display',
                    WM:          'Water alarm',
                    FL2:         'Coloured light therapy',
                    SW2:         'Underwater spotlight',
                    ALG:         'Fitting'
                },
            },
            form: {
                armatur:  'Fitting',
                option: 'OPTIONS',
                TA:     'Temperature display',
                WM:     'Water alarm',
                FL2:    'Coloured light therapy',
                SW2:    'Underwater spotlight',
                system: 'With whirl system',
            },

        },
        stepEight: {
            menu: {
                title: 'Sound system',
                body:  {
                    len:         '1',
                    1:           'Sound system',
                    soundsystem: 'Sound system',
                },
            },
            form: {
                system: 'With sound system',
            },
        },

        stepNine: {
            menu: {
                title: 'Surface',
                title2: 'Colour',
                body:  {
                    len:       '2',
                    1:         'white matte',
                    2:         'ANTIGLISS PRO, CLEANEFFECT',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'CLEANEFFECT',
                },
            },
            form: {
                ober:           'SURFACE TREATEMENT',
                glazePlus:      'CLEANEFFECT',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Remarks for custom design',
                colorName:      'Colour name',
                options:        [
                    'Colour name',
                ],
            },

        },


    },
    DWDF: {
        stepOne: {
            menu: {
                title: 'Made-to-measure',
                body:  {
                    len: '2',
                    1:   'Base dimensions:',
                    2:   'Actual dimensions:',
                },
            },
            form: {
                title:  'Base dimensions',
                width:  'WIDTH (CM)',
                length: 'LENGTH (CM)',
                to:     'to',
            },

        },
        stepTwo: {
            menu: {
                title: 'Tile flanges',
                body:  {
                    len:   '2',
                    1:     'Tile flange code',
                    2:     'Partial tile flanges',
                    back:  'back',
                    front: 'front',
                    left:  'left',
                    right: 'rechts',
                },
            },
            form: {
                title:    'Tile flange code:',
                checkbox: 'Partial tile flange',
                left:     'Left',
                right:    'Right',
                back:     'Back',
                front:    'Front',
            },
            summary: {
                Z23: {
                    '1':  "Tile flange back",
                    '02': "Partial tile flange back left",
                    '03': "Partial tile flange back right"
                },
                Z45: {
                    '1':  "Tile flange right",
                    '04': "Partial tile flange right back",
                    '05': "Partial tile flange right front"
                },
                Z67: {
                    '1':  "Tile flange front",
                    '06': "Partial tile flange front right",
                    '07': "Partial tile flange front left"
                },
                Z81: {
                    '1':  "Tile flange left",
                    '01': "Partial tile flange left back",
                    '08': "Partial tile flange left front"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Corner options',
                title2: 'Corner option',
                body:  {
                    len: '1',
                    1:   'Corner(s) defined',
                    EA12: 'Back left',
                    EA34: 'Back right',
                    EA78: 'Front left',
                    EA56: 'Front right',
                },
            },
            form: {
                back_left:   'Back left',
                back_right:  'Back right',
                front_left:  'Front left',
                front_right: 'Front right',
            },

        },
        stepFour: {
            menu: {
                title: 'Apron',
                sheight:  'Apron height:',
                body:  {
                    len:   '1',
                    1:     'Borehole for single hole tap fitting',
                    back:  'back',
                    front: 'front',
                    left:  'left',
                    right: 'right',
                },
            },
            form: {
                title:    'Apron code:',
                checkbox: 'Partial apron',
                sheight:  'Apron height (cm):',
                left:     'Left',
                right:    'Right',
                back:     'Back',
                front:    'Front',
            },
            summary: {
                S23: {
                    '1':  "Apron back",
                    '02': "Partial apron back left",
                    '03': "Partial apron back left"
                },
                S45: {
                    '1':  "Apron right",
                    '04': "Partial apron right back",
                    '05': "Partial apron right front"
                },
                S67: {
                    '1':  "Apron front",
                    '06': "Partial apron front right",
                    '07': "Partial apron front left"
                },
                S81: {
                    '1':  "Apron left",
                    '01': "Partial apron left back",
                    '08': "Partial apron left front"
                }
            }
        },
        stepFive: {
            menu: {
                title: 'Surface',
                title2: 'Colour',
                body:  {
                    len:       '2',
                    1:         'white matte',
                    2:         'ANTIGLISS PRO, CLEANEFFECT',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'CLEANEFFECT',
                    GT:        'ANTIGLISS PRO',
                    OV:        'CLEANEFFECT',
                },
            },
            form: {
                ober:           'SURFACE TREATMENT',
                glazePlus:      'CLEANEFFECT',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Remarks for custom design',
                colorName:      'Colour name',
                options:        [
                    'Colour name',
                ],
            },
        },

    },
    WT: {
        stepOne: {
            menu: {
                title: 'Made-to-measure',
                body:  {
                    len: '2',
                    1:   'Base dimensions:',
                    2:   'Actual dimensions:',
                },
                left:  'Axial dimension left:',
                front: 'Axial dimension front:'
            },
            form: {
                title: 'Basic dimensions',
                tiefe: 'DEPTH',
                width: 'WIDTH',
                to:    'to',
                left:  'AXIAL DIM. LEFT',
                front: 'AXIAL DIM. FRONT'
            },

        },
        stepTwo: {
            menu: {
                title: 'Custom hole drilling',
                body:  {
                    len:                      '2',
                    1:                        'Hole for fittings, soap dispenser,',
                    2:                        'Paper handkerchief dispenser, socket',
                    MISSING_WT_ALAZ_CHECKBOX: 'Faucet hole',
                    MISSING_WT_ALAZ_checkbox: 'Faucet hole',
                    MISSING_WT_ALS_CHECKBOX:  'Drill hole',
                    MISSING_WT_ALS_checkbox:  'Drill hole',
                    MISSING_SSPV_checkbox:    'Soap dispenser',
                    SSPV:                     'Soap dispenser',
                    ST:                       'Power socket',
                    HTH:                      'Towel holder',
                },
            },
            form: {
                armaturenloch:            'faucet hole',
                armatur:                  'Faucet hole',
                MISSING_WT_ALAZ_CHECKBOX: 'Faucet hole',
                MISSING_WT_ALAZ_checkbox: 'Faucet hole',
                MISSING_WT_ALS_CHECKBOX:  'Drill hole',
                MISSING_WT_ALS_checkbox:  'Drill hole',
                MISSING_SSPV_checkbox:    'Soap dispenser',
                SSPV:                     'Soap dispenser',
                ST:                       'Power socket',
                HTH:                      'Towel holder',
                position:                 'Faucet hole position',
                specialHole:              'Custom drill hole',
                loch3:                    '3-hole tap fitting',
                description:              'Description',
                drawing:                  'UPLOAD DRAWING',
                soapDispenser:            'Custom drill hole for soap dispenser',
                socket:                   'Custom drill hole for power socket',
                towerHolder:              'Custom drill hole for towel holder',
                left:                     'left',
                S:                        'S',
                A:                        'A',
            },

        },
        stepThree: {
            menu: {
                title: 'Further options',
                body:  {
                    len:  '2',
                    1:    'Tissue dispenser',
                    2:    'without overflow',
                    UL:   'without overflow',
                    UL_inverter:   'without overflow',
                    KTSV: 'Paper handkerchief dispenser',
                    MISSING_KTSV_checkbox: 'Paper handkerchief dispenser',
                },
            },
            form: {
                tissueDispensers: 'Tissue dispenser',
                UL:               'without overflow',
                KTSV:             'Tisse dispenser',
                position:         'Position',
                withoutOverflow:  'without overflow',
                above_left:       'back left',
                above_right:      'back right',
                bellow_left:      'front left',
                bellow_right:     'front right',
                text_field: {
                    placeholder: 'Remarks for custom design',
                },
            },

        },
        stepFour: {
            menu: {
                title: 'Surface',
                title2: 'Colour',
                body:  {
                    len:       '2',
                    1:         'white matte',
                    2:         'ANTIGLISS PRO, CLEANEFFECT',
                    antigliss: 'ANTIGLISS PRO',
                    glassur:   'ANTIGLISS PRO',
                    OV:        'CLEANEFFECT',
                },
            },
            form: {
                ober:           'SURFACE TREATMENT',
                glazePlus:      'CLEANEFFECT',
                antiglissPro:   'ANTIGLISS PRO',
                txtPlaceholder: 'Remarks for custom design',
                colorName:      'Colour name',
                options:        [
                    'Colour name',
                ],
            },


        },
    },
    KRW: {
        stepOne: {
            menu: {
                title: 'Made-to-measure',
                body:  {
                    len: '2',
                    1:   'Dimensions:',
                    2:   'Actual Dimensions:',
                },
            },
            form: {
                title:  'Dimensions',
                width:  'WIDTH (CM)',
                length: 'LENGTH (CM)',
                to:     'to',
            },

        },
        stepTwo: {
            menu: {
                title: 'Visible edges',
                body:  {
                    len:   '2',
                    1:     'Edge code',
                    back:  'top',
                    front: 'bottom',
                    left:  'left',
                    right: 'right',
                },
            },
            form: {
                title:    'Edge code:',
                checkbox: 'Tile flange',
                left:     'top',
                right:    'bottom',
                back:     'back',
                front:    'front',
            },
            summary: {
                SK23: {
                    '1':  " · visible edges top"
                },
                SK45: {
                    '1':  " · visible edges right"
                },
                SK67: {
                    '1':  " · visible edges bottom"
                },
                SK81: {
                    '1':  " · visible edges left"
                }
            }

        },
        stepThree: {
            menu: {
                title: 'Sockets',
                title2: 'Sockets',
                type: 'Socket type',
                socket: 'Socket',
                body:  {
                    ST1: 'Socket 1',
                    ST2: 'Socket 2',
                    ST3: 'Socket 3',
                    ST4: 'Socket 4',
                    ST5: 'Socket 5',
                },
            },
            form: {
                type: 'Socket type',
                socket: 'Socket',
                position_x: 'Position horizontal (cm)',
                position_y: 'Position vertical (cm)',
            },

        },
        stepFour: {
            menu: {
                title: 'Rectangular cutouts',
                body:  {
                    AS1: '(1)',
                    AS2: '(2)',
                    AS3: '(3)',
                    AS4: '(4)',
                    AS5: '(5)',
                },
                summary:  {
                    AS1: 'Cutout 1',
                    AS2: 'Cutout 2',
                    AS3: 'Cutout 3',
                    AS4: 'Cutout 4',
                    AS5: 'Cutout 5',
                },
            },
            form: {
                title: 'Cutouts',
                position_x: 'Position horizontal (cm)',
                position_y: 'Position vertical (cm)',
                size_x: 'Horizontal size (cm)',
                size_y: 'Vertical size (cm)',
            },

        },
        stepFive: {
            menu: {
                title: 'Round cutouts',
                body:  {
                    ASR1: '(1)',
                    ASR2: '(2)',
                    ASR3: '(3)',
                    ASR4: '(4)',
                    ASR5: '(5)',
                },
                summary:  {
                    ASR1: 'Round cutout 1',
                    ASR2: 'Round cutout 2',
                    ASR3: 'Round cutout 3',
                    ASR4: 'Round cutout 4',
                    ASR5: 'Round cutout 5',
                },
            },
            form: {
                title: 'Cutout',
                measure: 'Diameter (cm)',
                position_x: 'Horizontal position (cm)',
                position_y: 'Vertical position (cm)'
            },

        },
        stepSix: {
            menu: {
                title: 'Folded edges',
                body:  {
                    GK45: 'Folded edge right',
                    GK81: 'Folded edge left',
                },
            },
            form: {
                measure: 'Width (cm)',
                left: 'Left',
                right: 'Right',
            },

        },
        stepSeven: {
            menu: {
                title: 'Surface',
                title2: 'Color',
                body:  {
                    len:  '2',
                    OV:  'CLEANEFFECT',
                },
            },
            form: {
                ober:           'SURFACE TREATMENT',
                glazePlus:      'CLEANEFFECT',
                txtPlaceholder: 'Remarks for custom design',
                colorName:      'Color name',
                options:        [
                    'Color name',
                ],
            },

        },
    },
    previous:           'BACK',
    next:               'NEXT',
    downloadAndContact: {
        title:             'DOWNLOADS AND CONTACT',
        configurationCode: 'Configuration code:',
        schmidlinArtNo:    'Schmidln SKU:',
        SGNr:              'SGVSB-Nr.:',
        stNr:              'ST-Nr:',
        recommended:       'Recommended',
        salesPrice:        'Brutto-Price',
        totalPrice:        'Total cost',
        inquireQuotation:  'SUMMARY',
        order:             'SUBMIT ORDER',
        contactDealer:     'CONTACT DEALER',
    },
    currencyCHF: 'CHF',
    BREADCRUMBS: {
        sortiment:   'CATEGORY',
        model:       'MODEL',
        bathtub:     'BATHTUBS',
        wt:          'WASHBASINS',
        dwdf:        'SHOWER BASES',
        krw:         'KITCHEN SPLASHBACKS',
        showerTrays: 'SHOWER AREAS',
        washbasins:  'WASHBASINS',
        urinals:     'URINALS',
    },
    showPrices: 'Show prices',
    hidePrices: 'Hide prices',
}



// WEBPACK FOOTER //
// ./src/translations/english.js